import ButtonBase from '@/global/components/Button/ButtonBase'
import Menu from '@/global/components/MenuV2'
import { TextField } from '@mui/material'
import IconeAjuda from 'global/components/IconeAjuda'
import localeText from 'locales/datagrid'
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react'
import { useState } from 'react'

enum Paginas {
    RESUMO,
    // OPERADOR_LIGACAO,
    COLUNA,
    OPERADOR,
    VALOR,
}
const ultimaPagina = Paginas.VALOR

enum Operadores {
    CONTEM = 'contém',
    NAO_CONTEM = 'não contém',
    IGUAL = 'igual',
    INICIA_COM = 'inicia com',
    TERMINA_COM = 'termina com',
    ESTA_VAZIO = 'está vazio',
    NAO_ESTA_VAZIO = 'não está vazio',
    // QUALQUER_UM_DE = 'é qualquer um de',
    MATEMATICOS = 'matemáticos',
    ANTES_DE = 'antes de',
    DEPOIS_DE = 'depois de',
    ANTES_OU_IGUAL_A = 'antes ou igual a',
    DEPOIS_OU_IGUAL_A = 'depois ou igual a',
}

const DESCRICOES_OPERADORES = {
    [Operadores.CONTEM]: `O filtro mais utilizado, é usado para filtrar valores
    que contêm o valor que você deseja filtrar. Por exemplo,
    se você deseja filtrar valores que contêm a letra "a",
    você pode usar o filtro "contém" e inserir o valor "a"
    na caixa de texto ao lado do operador.`,
    [Operadores.NAO_CONTEM]: `É usado para filtrar valores que não contêm o valor que
    você deseja filtrar. Por exemplo, se você deseja filtrar
    valores que não contêm a letra "a", você pode usar o
    filtro "não contém" e inserir o valor "a" na caixa de
    texto ao lado do operador.`,
    [Operadores.IGUAL]: `É usado para filtrar valores que são exatamente iguais
    ao valor que você deseja filtrar. Por exemplo, se você
    deseja filtrar valores que são iguais a "Atestado", você pode
    usar o filtro "igual" e inserir o valor "Atestado" na caixa de
    texto ao lado do operador.`,
    [Operadores.INICIA_COM]: `É usado para filtrar valores que começam com o valor que
    você deseja filtrar. Por exemplo, se você deseja filtrar
    valores que começam com a letra "a", você pode usar o
    filtro "inicia com" e inserir o valor "a" na caixa de
    texto ao lado do operador.`,
    [Operadores.TERMINA_COM]: `É usado para filtrar valores que terminam com o valor
    que você deseja filtrar. Por exemplo, se você deseja
    filtrar valores que terminam com a letra "a", você pode
    usar o filtro "termina com" e inserir o valor "a" na
    caixa de texto ao lado do operador.`,
    [Operadores.ESTA_VAZIO]: `É usado para filtrar valores que estão vazios. Por
    exemplo, se você deseja filtrar valores que estão
    vazios, você pode usar o filtro "está vazio".`,
    [Operadores.NAO_ESTA_VAZIO]: `É usado para filtrar valores que não estão vazios. Por
    exemplo, se você deseja filtrar valores que não estão
    vazios, você pode usar o filtro "não está vazio".`,
    // [Operadores.QUALQUER_UM_DE]: `É usado para filtrar valores que são iguais a qualquer
    // um dos valores que você deseja filtrar. Por exemplo, se
    // você deseja filtrar valores que são iguais a "Horas extras" ou "Falta em horas",
    // você pode usar o filtro "é qualquer um de" e inserir o valor "Horas extras", clicar
    // no item que vai aparecer abaixo do campo, depois escrever "Falta em horas", clicar
    // novamente no item e o filtro será aplicado.`,
    [Operadores.MATEMATICOS]: `= (igual), != (diferente), > (maior), >= (maior ou igual), < (menor)
    e <= (menor ou igual) são operadores matemáticos. Eles são usados para filtrar valores
    numéricos. E se comportam da mesma forma que os operadores matemáticos que você já conhece.
    Só estão disponíveis para colunas numéricas e em tabelas específicas.`,
    [Operadores.ANTES_DE]: `É usado para filtrar valores que são antes da data que você
    deseja filtrar. Só estão disponíveis para colunas de data e em tabelas específicas.`,
    [Operadores.DEPOIS_DE]: `É usado para filtrar valores que são depois da data que você
    deseja filtrar. Só estão disponíveis para colunas de data e em tabelas específicas.`,
    [Operadores.ANTES_OU_IGUAL_A]: `É usado para filtrar valores que são antes ou iguais a data que você
    deseja filtrar. Só estão disponíveis para colunas de data e em tabelas específicas.`,
    [Operadores.DEPOIS_OU_IGUAL_A]: `É usado para filtrar valores que são depois ou iguais a data que você
    deseja filtrar. Só estão disponíveis para colunas de data e em tabelas específicas.`,
} as const

const Resumo = () => (
    <>
        <p>
            Para utilizar o filtro, você precisa selecionar as coluna que deseja
            filtrar, o operador que deseja usar e o valor que deseja filtrar.
        </p>
        <br />
        <p>
            Depois de selecionar a coluna, o operador e o valor, a tabela será
            atualizada. Você pode remover o filtro clicando no botão "
            {localeText.filterPanelDeleteIconLabel}" que fica na esquerda do
            campo "coluna".
        </p>
    </>
)

// const OperadorLigacao = () => (
//     <p>
//         O operador de ligação é usado para ligar dois filtros. Existem dois
//         operadores de ligação disponíveis, o "
//         {localeText.filterPanelOperatorAnd}" e o "
//         {localeText.filterPanelOperatorOr}". O operador "
//         {localeText.filterPanelOperatorAnd}" é usado mostrar apenas os
//         resultados que satisfazem todos os filtros. O operador "
//         {localeText.filterPanelOperatorOr}" é usado mostrar os resultados que
//         satisfazem pelo menos um dos filtros.
//     </p>
// );

const Coluna = () => (
    <p>
        O campo "coluna" se refere a coluna da tabela que você deseja filtrar.
        Você também pode selecionar a coluna clicando no cabeçalho da coluna e
        selecionando a opção "{localeText.filterPanelInputPlaceholder}".
    </p>
)

const Valor = () => (
    <p>
        O campo "valor" se refere ao valor que você quer enconrar no resultado.
        Você pode inserir o valor na caixa de texto ao lado do operador. Alguns
        operadores não precisam de um valor, como o operador "
        {localeText.filterOperatorIsEmpty}".
    </p>
)

const Operador = () => {
    const [operador, setOperador] = useState<Operadores>(Operadores.CONTEM)

    return (
        <>
            <p>
                O operador é o tipo de filtro que você deseja aplicar. Existem
                vários operadores disponíveis, como "
                {localeText.filterOperatorContains}" e "
                {localeText.filterOperatorIsEmpty}". Cada operador tem uma
                função diferente.
            </p>
            <br />
            <div style={{ paddingLeft: '20px' }}>
                <TextField
                    SelectProps={{
                        value: operador,
                    }}
                    select
                    onKeyDownCapture={e => e.stopPropagation()}
                    variant="outlined"
                    size="small"
                >
                    {Object.values(Operadores).map(operador => (
                        <Menu.Item
                            key={operador}
                            value={operador}
                            onClick={() => {
                                setOperador(operador)
                            }}
                        >
                            {operador}
                        </Menu.Item>
                    ))}
                </TextField>
                <br />
                <br />
                <span>{DESCRICOES_OPERADORES[operador as Operadores]}</span>
            </div>
        </>
    )
}

export default function AjudaFiltros() {
    const [pagina, setPagina] = useState<Paginas>(Paginas.RESUMO)

    const proximaPagina = () => {
        const temProxima = pagina < ultimaPagina
        if (temProxima) setPagina(pagina + 1)
    }

    const paginaAnterior = () => {
        const temAnterior = pagina > 0
        if (temAnterior) setPagina(pagina - 1)
    }

    return (
        <IconeAjuda>
            <div className="flex justify-between items-center">
                <span className="font-bold text-lg">
                    Como utilizar o filtro
                </span>
                <div className="flex items-center w-fit">
                    <ButtonBase
                        title="Página anterior"
                        onClick={paginaAnterior}
                        disabled={pagina === 0}
                        variant="outline"
                        size="icon"
                    >
                        <ChevronLeftIcon />
                    </ButtonBase>
                    <span className="w-28 text-center">
                        {pagina === Paginas.RESUMO && 'Resumo'}
                        {pagina === Paginas.COLUNA && 'Coluna'}
                        {pagina === Paginas.OPERADOR && 'Operador'}
                        {pagina === Paginas.VALOR && 'Valor'}
                    </span>
                    <ButtonBase
                        title="Próxima página"
                        variant="outline"
                        size="icon"
                        onClick={proximaPagina}
                        disabled={pagina === ultimaPagina}
                    >
                        <ChevronRightIcon />
                    </ButtonBase>
                </div>
            </div>
            <br />
            {pagina === Paginas.RESUMO && <Resumo />}
            {/* {pagina === Paginas.OPERADOR_LIGACAO && <OperadorLigacao />} */}
            {pagina === Paginas.COLUNA && <Coluna />}
            {pagina === Paginas.OPERADOR && <Operador />}
            {pagina === Paginas.VALOR && <Valor />}
        </IconeAjuda>
    )
}
